

export class UserAddVehicleGroupIdInput implements IUserAddVehicleGroupIdInput {
    /** The auto-generated id of the vehicle group */
    vehicleGroupId!: number;

    constructor(data?: IUserAddVehicleGroupIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleGroupId = _data["vehicleGroupId"];
        }
    }

    static fromJS(data: any): UserAddVehicleGroupIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddVehicleGroupIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleGroupId"] = this.vehicleGroupId;
        return data; 
    }
}

export interface IUserAddVehicleGroupIdInput {
    /** The auto-generated id of the vehicle group */
    vehicleGroupId: number;
}

